// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table-wrapper.table-wrapper--base-related-lead[data-v-1e3909dd] {\n  min-height: 0 !important;\n}\n.table-wrapper.table-wrapper--related-leads[data-v-1e3909dd] {\n  max-height: initial !important;\n}", ""]);
// Exports
module.exports = exports;
